import { render, staticRenderFns } from "./ChainTable.vue?vue&type=template&id=73285288"
import script from "./ChainTable.vue?vue&type=script&lang=js"
export * from "./ChainTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports